import * as classNames from 'classnames';

interface ArticleCalcalistTopStoryHeaderProps {
  siteLayoutType: any;

}

interface ArticleCalcalistTopStoryHeaderState {
  chapters: string[];
  currentChapterIndex: number;
  isSelectOpen: boolean;
}  

export class ArticleCalcalistChapterMenu extends React.Component<ArticleCalcalistTopStoryHeaderProps, ArticleCalcalistTopStoryHeaderState> {
  public static siteScriptName = 'ArticleCalcalistChapterMenu';

  private chatpersObserver: IntersectionObserver | null = null;
  private chaptersNodes: HTMLElement[] = [];
  private HEIGHT_OFFSET = 0;
  private disableObserver = false;

  constructor(props: ArticleCalcalistTopStoryHeaderProps) {
    super(props);
    this.state = {
      chapters: [],
      currentChapterIndex: -1,
      isSelectOpen: false
    };
  }

  componentDidMount() {
    this.initHeaderOffsetHeight();
    document.addEventListener('click', this.handleClickOutside);
    this.waitForChapters();
  }

  waitForChapters = (retries = 10) => {
    const chapters = document.querySelectorAll('h3.chatper_title');
    if (chapters.length > 0) {
      this.initChapters();
      this.initObserver();
    } else if (retries > 0) {
      setTimeout(() => this.waitForChapters(retries - 1), 750);
    }
  };

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    if (this.chatpersObserver) {
      this.chatpersObserver.disconnect();
    }
  }

  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (this.state.isSelectOpen && !target.closest('.chapter-select-container')) {
      this.setState({ isSelectOpen: false });
    }
  };

  initHeaderOffsetHeight = () => {
    const headerEl =
      document.querySelector('.header-calcalist');
    if (!headerEl) {
      return;
    }
    this.HEIGHT_OFFSET = headerEl.clientHeight;
  };

  initChapters = () => {
    const chapters: string[] = [];
    const chaptersNodes: HTMLElement[] = [];
    document.querySelectorAll('h3.chatper_title').forEach((chapter: HTMLElement) => {
      const textValue = (chapter as HTMLElement).innerText.trim();

      if (textValue) {
        chapters.push(textValue);
        chaptersNodes.push(chapter);
      }
    });
    this.chaptersNodes = chaptersNodes;
    this.setState({ chapters });
  };

  initObserver = () => {
    if (IntersectionObserver) {
      const chaptersOberveseroptions: IntersectionObserverInit = {
        rootMargin: `-${this.HEIGHT_OFFSET}px 0px -${(window.innerHeight / 3) * 2}px 0px`,
        threshold: 0,
      };

      this.chatpersObserver = new IntersectionObserver(
        (entries) => this.handleChaptersIntersections(entries),
        chaptersOberveseroptions,
      );
      document
        .querySelectorAll('h3.chatper_title')
        .forEach((node) => (node as any).innerText.trim() && this.chatpersObserver.observe(node));
    }
  };

  handleChaptersIntersections = (entries: IntersectionObserverEntry[]) => {
    if (this.disableObserver) {
      return;
    }
    const filteredEntries = entries
      .filter((entry) => entry.isIntersecting && !!(entry.target as any).innerText.trim())
      .sort((a, b) => b.boundingClientRect.top - a.boundingClientRect.top);

    if (filteredEntries.length > 0) {
      const topEntry = filteredEntries[0];
      const element = topEntry.target as HTMLElement;
      const chapText = element.innerText.trim();
      const index = this.state.chapters.findIndex((chapter) => chapter === chapText);
      if (index >= 0) {
        this.setState({ currentChapterIndex: index });
      }
    }
  };

  handleChapterClick = (chapterIndex: number) => {
    const { chapters } = this.state;
    const { siteLayoutType } = this.props;
    const { top } = this.chaptersNodes[chapterIndex].getBoundingClientRect();

    const y = window.scrollY + top - this.HEIGHT_OFFSET;
    this.disableObserver = true;
    
    this.setState({ 
      currentChapterIndex: chapterIndex,
      isSelectOpen: false 
    });

    window.scrollTo({ top: y - 60, behavior: 'smooth' });

    setTimeout(() => {
      this.disableObserver = false;
    }, 1500);

    this.getClickedChapterAnalytics(`componenta_name=chaptered_article_body_menu&content_type=menu&click_text=${chapters[chapterIndex]}`, siteLayoutType);
  };

  toggleSelect = () => {
    this.setState({ isSelectOpen: !this.state.isSelectOpen });
  };

  getClickedChapterAnalytics = (text, siteLayoutType) => {
    if (siteLayoutType === 'mobileApp' && typeof window != "undefined") {
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.onClickChapter.postMessage(text);
      }
      if (window.Android) {
        window.Android.onClickChapter(text);
      }
    }  
  };

  render() {
    const { chapters, currentChapterIndex, isSelectOpen } = this.state;
    const hasSelected = currentChapterIndex >= 0;
    const currentChapterTitle = 'נושאים מרכזיים';

    return (
        <div className={`article-calcalist-chapter-menu-container  ${chapters.length > 0 ? "" : "noChapters"}`}>
            <div className={`article-calcalist-chapter-menu ${chapters.length > 0 ? "" : "noChapters"}`}>
                <div className="chapter-select-container"> 
                {!!chapters.length && (
                <>
                    <div 
                    className={classNames('chapter-select-button', { open: isSelectOpen, selected: hasSelected })}
                    onClick={this.toggleSelect}
                    >
                    <span className="select-arrow"></span>
                    <span className="current-chapter">{currentChapterTitle}</span>
                    
                    </div>
                    
                    {isSelectOpen && (
                    <div className="chapter-dropdown">
                        {chapters.map((chapter, index) => (
                        <div
                            key={index}
                            className={classNames('chapter-option', { 
                            selected: index === currentChapterIndex 
                            })}
                            onClick={() => this.handleChapterClick(index)}
                        >
                            {chapter}
                        </div>
                        ))}
                    </div>
                    )}
                </>
                )}
            </div>
        </div>
        </div>
    );
  }
}